import get from 'lodash/get';

function getDefinitions($t, twinOrManyTwins, { customParameters, keyValueAtributes } = {}) {
  const statics = {
    'twin.id': {
      key: 'id',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.id'),
    },
    'twin.title': {
      key: 'title',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.title'),
    },
    'twin.description': {
      key: 'data.description',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.description'),
    },
    'twin.tenant_name': {
      key: 'tenant.name',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.tenantName'),
    },
    'twin.icon': {
      key: 'data.faIcon',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.icon'),
      component: 'twin-table-icon-column',
    },
    'twin.tags': {
      key: 'data.tags',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.tags'),
      transformer: (tags) => {
        if (!tags) {
          return '';
        }

        if (!Array.isArray(tags)) {
          return tags;
        }

        return tags.filter((t) => t.trim().length > 0).join(', ');
      },
    },
    'twin.address': {
      key: 'data.address.formatted_address',
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.address'),
    },
  };

  const twinArray = [];
  if (twinOrManyTwins) {
    if (Array.isArray(twinOrManyTwins)) {
      twinArray.push(...twinOrManyTwins);
    } else {
      twinArray.push(twinOrManyTwins);
    }
  }

  const dynamics = {};

  const stateKeys = new Set();

  twinArray.forEach((twin) => {
    const keyValuePairs = get(twin, 'data.keyValue', {});

    const allKeyValues = new Set([...(keyValueAtributes || []), ...Object.keys(keyValuePairs)]);
    allKeyValues.forEach((key) => {
      dynamics[`twin.key_value__${key}`] = {
        key: `data.keyValue.${key}`,
        defaultLabel: $t('Dashboards.twinFields.defaultLabel.keyValue', { key }),
      };
    });

    Object.keys(twin._states || {}).forEach((stateKey) => {
      stateKeys.add(stateKey);
    });
  });

  Object.keys(customParameters || {}).forEach((key) => {
    if (!key.trim()) {
      return;
    }
    dynamics[`dashboard.parameters.${key}`] = {
      key: `dashboard.parameters.${key}`,
      defaultLabel: $t('Dashboards.twinFields.defaultLabel.customParameter', { key }),
    };
  });

  const complete = {
    ...statics,
    ...dynamics,
  };

  return complete;
}

function evaluateTemplate({ i18n_t, twin: twinOrManyTwins, template, customParameters }) {
  const definitions = getDefinitions(i18n_t, twinOrManyTwins, { customParameters });
  const twinArray = Array.isArray(twinOrManyTwins) ? twinOrManyTwins : [twinOrManyTwins];

  let evaluatedTemplate = template;
  Object.entries(definitions).forEach(([keyToReplace, definition]) => {
    let definitionEvaluation = '';

    if (definition.key.startsWith('dashboard.parameters.')) {
      definitionEvaluation = customParameters[definition.key.replace('dashboard.parameters.', '')];
      if (definition.transformer) {
        definitionEvaluation = definition.transformer(definitionEvaluation);
      }
    } else {
      const twinEvaluations = twinArray
        .map((twin) => {
          let evaluation = get(twin, definition.key);

          if (definition.transformer) {
            evaluation = definition.transformer(evaluation);
          }

          return evaluation;
        })
        .filter((i) => i !== undefined);

      definitionEvaluation = twinEvaluations.join(', ');
    }

    evaluatedTemplate = evaluatedTemplate.split(`{${keyToReplace}}`).join(definitionEvaluation);
  });

  return evaluatedTemplate;
}

export default {
  getDefinitions,
  evaluateTemplate,
};
